export const push = (jsonObject) => {
  window.dataLayer.push(jsonObject);
};
